import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import loginJa from "./locales/ja/login.json";
import loginEn from "./locales/en/login.json";
import dashboardJa from "./locales/ja/dashboard.json";
import dashboardEn from "./locales/en/dashboard.json";
import settingJa from "./locales/ja/setting.json";
import settingEn from "./locales/en/setting.json";
import boardJa from "./locales/ja/board.json";
import boardEn from "./locales/en/board.json";
import taskJa from "./locales/ja/task.json";
import taskEn from "./locales/en/task.json";
import analyticsJa from "./locales/ja/analytics.json";
import analyticsEn from "./locales/en/analytics.json";
import settlementJa from "./locales/ja/settlement.json";
import settlementEn from "./locales/en/settlement.json";
import driverShiftJa from "./locales/ja/driverShift.json";
import driverShiftEn from "./locales/en/driverShift.json";
import guestJa from "./locales/ja/guest.json";
import guestEn from "./locales/en/guest.json";
import callHistoryJa from "./locales/ja/callHistory.json";
import callHistoryEn from "./locales/en/callHistory.json";
import castShiftJa from "./locales/ja/castShift.json";
import castShiftEn from "./locales/en/castShift.json";
import aiSupportJa from "./locales/ja/aiSupport.json";
import aiSupportEn from "./locales/en/aiSupport.json";
import companyJa from "./locales/ja/company.json";
import companyEn from "./locales/en/company.json";
import requestGuestJa from "./locales/ja/requestGuest.json";
import requestGuestEn from "./locales/en/requestGuest.json";
import orderJa from "./locales/ja/order.json";
import orderEn from "./locales/en/order.json";
import castScheduleJa from "./locales/ja/castSchedule.json";
import castScheduleEn from "./locales/en/castSchedule.json";
import masterJa from "./locales/ja/master.json";
import masterEn from "./locales/en/master.json";
import notificationJa from "./locales/ja/notification.json";
import notificationEn from "./locales/en/notification.json";
import layoutJa from "./locales/ja/layout.json";
import layoutEn from "./locales/en/layout.json";
import accountingJa from "./locales/ja/accounting.json";
import accountingEn from "./locales/en/accounting.json";
import paymentJa from "./locales/ja/payment.json";
import paymentEn from "./locales/en/payment.json";
import bookEmailJa from "./locales/ja/bookEmail.json";
import bookEmailEn from "./locales/en/bookEmail.json";
import orderListJa from "./locales/ja/orderList.json";
import orderListEn from "./locales/en/orderList.json";
import guestAnalyticsJa from "./locales/ja/guestAnalytics.json";
import guestAnalyticsEn from "./locales/en/guestAnalytics.json";
import castRankingJa from "./locales/ja/castRanking.json";
import castRankingEn from "./locales/en/castRanking.json";
import messageTemplateJa from "./locales/ja/messageTemplate.json";
import messageTemplateEn from "./locales/en/messageTemplate.json";
import signupJa from "./locales/ja/signup.json";
import signupEn from "./locales/en/signup.json";
import marketingMailJa from "./locales/ja/marketingMail.json";
import marketingMailEn from "./locales/en/marketingMail.json";
import commonJa from "./locales/ja/common.json";
import commonEn from "./locales/en/common.json";

const resources = {
  ja: {
    login: loginJa,
    dashboard: dashboardJa,
    setting: settingJa,
    board: boardJa,
    task: taskJa,
    analytics: analyticsJa,
    settlement: settlementJa,
    driverShift: driverShiftJa,
    guest: guestJa,
    callHistory: callHistoryJa,
    castShift: castShiftJa,
    aiSupport: aiSupportJa,
    company: companyJa,
    requestGuest: requestGuestJa,
    order: orderJa,
    castSchedule: castScheduleJa,
    master: masterJa,
    notification: notificationJa,
    layout: layoutJa,
    accounting: accountingJa,
    payment: paymentJa,
    bookEmail: bookEmailJa,
    orderList: orderListJa,
    guestAnalytics: guestAnalyticsJa,
    castRanking: castRankingJa,
    messageTemplate: messageTemplateJa,
    signup: signupJa,
    marketingMail: marketingMailJa,
    common: commonJa,
  },
  en: {
    login: loginEn,
    dashboard: dashboardEn,
    setting: settingEn,
    board: boardEn,
    task: taskEn,
    analytics: analyticsEn,
    settlement: settlementEn,
    driverShift: driverShiftEn,
    guest: guestEn,
    callHistory: callHistoryEn,
    castShift: castShiftEn,
    aiSupport: aiSupportEn,
    company: companyEn,
    requestGuest: requestGuestEn,
    order: orderEn,
    castSchedule: castScheduleEn,
    master: masterEn,
    notification: notificationEn,
    layout: layoutEn,
    accounting: accountingEn,
    payment: paymentEn,
    bookEmail: bookEmailEn,
    orderList: orderListEn,
    guestAnalytics: guestAnalyticsEn,
    castRanking: castRankingEn,
    messageTemplate: messageTemplateEn,
    signup: signupEn,
    marketingMail: marketingMailEn,
    common: commonEn,
  },
};

const savedLang =
  typeof window !== "undefined" && window.localStorage
    ? window.localStorage.getItem("lang")
    : null;

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLang === "en" || savedLang === "ja" ? savedLang : "ja",
    fallbackLng: "ja",
    interpolation: {
      escapeValue: false,
    },
    ns: ["login", "dashboard", "setting", "board", "task", "analytics", "settlement", "driverShift", "guest", "callHistory", "castShift", "aiSupport", "company", "requestGuest", "order", "castSchedule", "master", "notification", "layout", "accounting", "payment", "bookEmail", "orderList", "guestAnalytics", "castRanking", "messageTemplate", "signup", "marketingMail", "common"],
    defaultNS: "login",
  });

export default i18n;
